export class BrokerRate {
  maxPrice: number;
  fulfillDynamicPrice: number;
  fulfillFixedPrice: number;
  publishWholeCharter: number;
  publishSharedCharter: number;
}
